<template>
  <div :class="!qr.isVerified ? 'flex flex-col mx-auto' : 'mx-auto'">
    <TheQR
      class="my-8"
      v-if="!qr.isVerified"
      @saveBypass="saveBypass"
      @eQrLoaded="eQrLoaded"
      @clearNewInterval="clearNewInterval"
    />

    <form
      class="
      form
      w-11/12
      md:w-8/12
      xl:w-6/12
      ws:w-4/12
      mx-auto
      items-center
      flex-col
      mt-40
      border
      p-6
      rounded-md
      border-gray-400
      bg-white
      shadow-xl
    "
      @submit.prevent="submit"
      v-else-if="
        showForm &&
          (this.$store.getters.getTokenExpiry < new Date().getTime() / 1000 ||
            qr.isVerified)
      "
    >
      <FormError v-if="formError.length > 0" :errorMessages="formError" />

      <div
        class="w-full border rounded-sm p-4 text-white bg-blue-500 text-center"
      >
        {{ loginMessage }}
      </div>
      <div class="my-4">
        <label class="block mb-1">Username</label>
        <input class="form__input" v-model="formData.username" ref="username" />
        <div class="form-error" v-if="$v.formData.username.$error && submitted">
          <span class="form-error__text" v-if="!$v.formData.username.required"
            >This field is required.</span
          >
          <span class="form-error__text" v-if="!$v.formData.username.minLength"
            >Username must be at least
            {{ $v.formData.username.$params.minLength.min }} characters</span
          >
        </div>
      </div>
      <div class="mb-4">
        <label class="block mb-1">Password</label>
        <input
          type="password"
          class="form__input"
          v-model="formData.password"
        />
        <div class="form-error" v-if="$v.formData.password.$error && submitted">
          <span class="form-error__text" v-if="!$v.formData.password.required"
            >This field is required.</span
          >
          <span class="form-error__text" v-if="!$v.formData.password.minLength"
            >Password must be at least
            {{ $v.formData.password.$params.minLength.min }} characters</span
          >
        </div>
      </div>
      <div>
        <label class="block mb-1">Group Code</label>
        <input type="text" class="form__input" v-model="formData.group_code" />
        <div
          class="form-error"
          v-if="$v.formData.group_code.$error && submitted"
        >
          <span class="form-error__text" v-if="!$v.formData.group_code.required"
            >This field is required.</span
          >
          <span class="form-error__text" v-if="!$v.formData.group_code.numeric"
            >Group Code must only contain numbers</span
          >
          <span
            class="form-error__text"
            v-if="!$v.formData.group_code.minLength"
            >Group Code must be
            {{ $v.formData.group_code.$params.minLength.min }} digits</span
          >
          <span
            class="form-error__text"
            v-if="!$v.formData.group_code.maxLength"
            >Group Code must be
            {{ $v.formData.group_code.$params.maxLength.max }} digits</span
          >
        </div>
      </div>
      <p class="text-red-500 my-4 text-sm font-medium">{{ loginResponse }}</p>
      <div>
        <BaseButton type="submit">Sign In</BaseButton>
      </div>
    </form>
  </div>
</template>

<script>
import {
  required,
  minLength,
  numeric,
  maxLength,
} from "vuelidate/lib/validators";

import TheQR from "@/components/TheQR";
import { qr } from "@/services/qr";

export default {
  components: {
    TheQR,
  },
  data: () => {
    return {
      qr: qr,
      loginResponse: "",
      formData: {
        username: "",
        password: "",
        bypass: 0,
        bpcode: null,
        qr: null,
      },
      submitted: false,
      showForm: true,
      bypass: null,
      formError: [],
      newInterval: null,
    };
  },
  created() {
    qr.isVerified = false;

    if (this.$store.getters.isLoggedIn && this.$store.getters.getTokenExpiry) {
      if (this.$store.getters.getTokenExpiry < new Date().getTime() / 1000) {
        if (!process.env.VUE_APP_QR_LOCK) qr.isVerified = true;
      } else {
        this.showForm = false;
        this.$router.push({ name: "Profile" });
      }
    } else {
      if (!process.env.VUE_APP_QR_LOCK) qr.isVerified = true;
    }
  },
  validations: {
    formData: {
      username: {
        required,
        minLength: minLength(3),
      },
      password: {
        required,
        minLength: minLength(5),
      },
      group_code: {
        required,
        numeric,
        minLength: minLength(3),
        maxLength: maxLength(3),
      },
    },
  },
  computed: {
    loginMessage() {
      return this.$store.getters.getLoginMessage;
    },
  },
  methods: {
    clearNewInterval(intId) {
      this.newInterval = intId;
    },
    eQrLoaded(qrCode) {
      this.formData.qr = qrCode;
    },
    saveBypass(code) {
      this.formData.bpcode = code;
      this.formData.bypass = 1;
    },
    checkBypass() {
      this.$store.commit("toggleLoading");
      this.$http
        .get(process.env.VUE_APP_API_URL + "/auth/bypass/" + this.bypass)
        .then((res) => {
          if (res.data.success === true) {
            this.qrVerified = true;
            this.formData.bypass = 1;
            this.formData.bpcode = this.bypass;
            clearInterval(this.newInterval);
            this.$nextTick(() => {
              this.$refs.username.focus();
            });
          }
        })
        .finally(() => {
          this.$store.commit("toggleLoading");
        });
    },
    submit: function() {
      if (!this.loading) {
        this.submitted = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.$store.commit("toggleLoading");
        this.$store
          .dispatch("login", this.formData)
          .then(() => {})
          .catch((err) => {
            this.loginResponse = err.response.data.message
              ? err.response.data.message
              : err.response.data.error;
            if (err.response) {
              this.formError = [];

              if (err.response.status == 404) {
                // this.formError[0] = '<pre>' + error.response.data.meta + '</pre>';
              } else if (err.response.status == 409) {
                // this.formError[0] = error.response.data;
              } else {
                const { data } = err.response.data;
                for (var error in data) {
                  this.formError.push(data[error]);
                }
              }
            }
          })
          .finally(() => {
            this.$store.commit("toggleLoading");
          });
      }
    },
  },
};
</script>
